<template>
  <div :class="{'component': config.layout !== 'fullWidth'}" v-bind:id="config.id">
    <title-component :config="config" v-if="config.type === 'page-title'" />
    <image-text-component :config="config" v-else-if="config.type === 'image'" />
    <image-text-component :config="config" v-else-if="config.type === 'image-text'" />
    <image-text-component :config="config" v-else-if="config.type === 'image-with-caption'" />
    <image-text-component :config="config" v-else-if="config.type === 'image-with-text-box'" />
    <hero-component :config="config" v-if="config.type === 'hero'" />
    <text-component :config="config" v-else-if="config.type === 'text'" />
    <product-list-component :config="config" v-else-if="config.type === 'product-list'" />
    <product-list-component :config="config" v-else-if="config.type === 'product-shelf'" />
    <!-- <horizontal-line-component :config="config" v-else-if="config.type === `horizontal-line`" /> -->
    <quote-component :config="config" v-else-if="config.type === `quote`" />
    <button-link-component :config="config" v-else-if="config.type === `button-link`" />
    <page-list-component :config="config" v-else-if="config.type === `page-list`" />
    <video-component :config="config" v-else-if="config.type === `video`" />
  </div>
</template>

<script>
import TitleComponent from "./TitleComponent";
import HeroComponent from "./HeroComponent";
import ImageTextComponent from "./ImageTextComponent";
import TextComponent from "./TextComponent";
import ProductListComponent from "./ProductListComponent";
import HorizontalLineComponent from "./HorizontalLineComponent";
import QuoteComponent from "./QuoteComponent";
import ButtonLinkComponent from "./ButtonLinkComponent";
import PageListComponent from "./PageListComponent";
import VideoComponent from "./VideoComponent";

export default {
  components: {
    TitleComponent,
    ProductListComponent,
    ImageTextComponent,
    HeroComponent,
    TextComponent,
    HorizontalLineComponent,
    QuoteComponent,
    ButtonLinkComponent,
    PageListComponent,
    VideoComponent
  },
  props: ["config"],
  data() {
    return {
      pageConfig: []
    };
  },
  mounted() {},
  methods: {}
};
</script>

<style scoped>
.component {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/cms/pageComponents/ComponentWrapper.vue